import moment from 'moment'

const maxWeeks = 6
const monthsLabel = ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Pażdziernik", "Listopad", "Grudzień"]
const daysLabel = ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"]

function determineFirstDateInItems(inputDate) {
    var startDay = inputDate.startOf('month').day()
    if (startDay === 0) { // niedziela
        return inputDate.subtract(6, 'days')
    }
    var firstDayOfMonth = startDay - 1
    if (firstDayOfMonth === 0) { // poniedzialek
        return inputDate.subtract(7, 'days')
    }
    return inputDate.subtract(firstDayOfMonth, 'days')
}

function isToday(inputDate) {
    return moment().format("YYYY-MM-DD") === inputDate.format("YYYY-MM-DD")
}

function isCurrentMonth(currentDate, inputDate) {
    return inputDate.month() === currentDate.month()
}

function buildEmptyDayItems(inputDate) {
    var currentDate = determineFirstDateInItems(moment(inputDate))
    const dayItems = new Array(maxWeeks);
    for (var week = 0; week < maxWeeks; week++) {
        dayItems[week] = new Array(daysLabel.length)
        for (var day = 0; day < daysLabel.length; day++) {
            dayItems[week][day] = {
                "week": week,
                "dayIndex": day,
                "dayLabel": daysLabel[day],
                "dateId": currentDate.format("YYYY-MM-DD"),
                "day":  currentDate.date(),
                "isToday": isToday(currentDate),
                "isCurrentMonth": isCurrentMonth(currentDate, inputDate),
                "entries": [],
                "status": {}
            }
            currentDate = currentDate.add(1, "days")
        }
    }
    return dayItems
}

function fetchDaysParams(items) {
    return {
        startDay: items[0][0].dateId,
        endDay: items[maxWeeks -1][daysLabel.length - 1].dateId
    }
}

function fetchStatsParams(items) {
    var result = []
    for (var week = 0; week < maxWeeks; week++) {
        for (var day = 0; day < daysLabel.length; day++){
            const item = items[week][day]
            if (item.isCurrentMonth) {
                result.push(item)
            }
        }
    }
    return {
        startDay: result[0].dateId,
        endDay: result[result.length - 1].dateId
    }
}

function findDayItemByDateId(items, dateId) {
    for (var week = 0; week < maxWeeks; week++) {
        for (var day = 0; day < daysLabel.length; day++){
            const item = items[week][day]
            if (item.dateId === dateId) {
                return item
            }
        }
    }
    return 0
}

export default {
    "findDayItemByDateId": findDayItemByDateId,
    "fetchDaysParams": fetchDaysParams,
    "fetchStatsParams": fetchStatsParams,
    "daysLabel": daysLabel,
    "monthsLabel": monthsLabel,
    "buildEmptyDayItems": buildEmptyDayItems
}


// WEBPACK FOOTER //
// ./src/components/schedule/SchedulePattern.js